module.exports = __webpack_public_path__ + "static/media/defender.42985208.webp";